import { Component, Host, h, Prop, Element, State } from '@stencil/core';
import { type BlogPostPreview } from '../../../../types/blog';

@Component({
  tag: 'sy-blog-highlights-card',
  styleUrl: './sy-blog-highlights-card.scss',
  shadow: true,
})
export class SyBlogHighlightsCard {
  @Element() host: HTMLSyBlogHighlightsCardElement;

  /**
   * Post preview to display
   */
  @Prop() preview: BlogPostPreview;

  @State() portrait = false;

  componentDidLoad() {
    const resizeObserver = new ResizeObserver((entries) => {
      entries.forEach((entry) => {
        this.portrait =
          window.matchMedia('(max-width: 768px)').matches || entry.contentRect.width / entry.contentRect.height < 4 / 3;
      });
    });

    resizeObserver.observe(this.host);
  }

  render() {
    if (!this.preview) {
      return (
        <Host>
          <div
            class={{
              grid: true,
              portrait: this.portrait,
            }}
          >
            <div class="info">
              <sy-text class="category skeleton" type="body">
                <sy-blog-skeleton-load />
              </sy-text>
              <sy-text class="title skeleton" type="h3">
                <sy-blog-skeleton-load />
              </sy-text>
              <sy-text class="description skeleton" type="body">
                <sy-blog-skeleton-load media />
              </sy-text>
              <div class="flex-row">
                <div class="author skeleton">
                  <sy-blog-skeleton-load />
                </div>
                <sy-text class="update-date skeleton" type="small">
                  <sy-blog-skeleton-load />
                </sy-text>
              </div>
            </div>
            <div class="image skeleton">
              <sy-blog-skeleton-load media />
            </div>
          </div>
        </Host>
      );
    }
    return (
      <Host>
        {this.preview && (
          <a href={this.preview.link}>
            <div
              class={{
                grid: true,
                portrait: this.portrait,
              }}
            >
              <div class="info">
                <sy-text class="category" type="body">
                  {this.preview.category}
                </sy-text>

                <sy-text class="title" type="h3">
                  {this.preview.title}
                </sy-text>

                {this.preview.description && (
                  <sy-text class="description" type="body">
                    {this.preview.description}
                  </sy-text>
                )}

                <div class="flex-row">
                  {this.preview.author ? (
                    <div class="author">
                      <sy-avatar image={this.preview.author.photoURL} rounded small></sy-avatar>
                    </div>
                  ) : (
                    <div class="author" />
                  )}
                  <sy-text class="update-date" type="small">
                    {this.preview.date}
                  </sy-text>
                </div>
              </div>
              <div class="image">
                <img loading="eager" class={{ portrait: this.portrait }} src={this.preview.img?.src}></img>
              </div>
            </div>
          </a>
        )}
      </Host>
    );
  }
}
